import { useSelector } from 'react-redux';
import { getDarkModeOverride } from '../selectors/getDarkModeOverride';

export const useTheme = () => {
    const darkModeOverride = useSelector(getDarkModeOverride);
    const systemPreference =  window?.matchMedia('(prefers-color-scheme: dark)')?.matches ? 'dark' : 'light';
    return (darkModeOverride === true || systemPreference === 'dark') ? 'dark' : 'light';
}
;
